import { render } from "./LoadingPage.vue?vue&type=template&id=78b56ad3"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__